import request from '@/utils/request'

// 答题收藏

let QuestionCollectApi = {
    
    /*列表*/
    getList(data, errorback) {
        return request._post('/shop/study.question_collect/index', data, errorback);
    }
}

export default QuestionCollectApi;



// WEBPACK FOOTER //
// ./src/api/study/question_collect.js